import { v4 as uuidv4 } from 'uuid';

export function AddToCartButton(props) {
	return {
		componentName: 'AddToCartButton',
		componentId: uuidv4(),
		props: Object.assign(
			{
				onClickBehavior: 'add-to-cart',
				onClickEventPropagation: 'enabled',
				isOneClickBuy: false,
				text: 'Adicionar ao carrinho',
				unavailableText: 'Indisponível',
				customToastUrl: '/',
				blockClass: 'class',
			},
			props,
		),
	};
}
